import { Tooltip } from 'antd';

// 样式常量
const CELL_STYLE = {
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  cursor: 'pointer',
};

export const config = {
  rowSelection: false,
  pagination: false,
  columns: [
    {
      title: '问题',
      dataIndex: 'issue',
      width: 300,
      ellipsis: true,
    },
    {
      title: '问题分类',
      dataIndex: 'issueCategory',
      width: 200,
    },
    {
      title: '问卷名称',
      dataIndex: 'questionnaireName',
      width: 200,
    },
    {
      title: '评分数量',
      dataIndex: 'scoreSize',
      width: 150,
    },
    {
      title: '1分数量',
      dataIndex: 'score1Size',
      width: 120,
    },
    {
      title: '2分数量',
      dataIndex: 'score2Size',
      width: 120,
    },
    {
      title: '3分数量',
      dataIndex: 'score3Size',
      width: 120,
    },
    {
      title: '4分数量',
      dataIndex: 'score4Size',
      width: 120,
    },
    {
      title: '5分数量',
      dataIndex: 'score5Size',
      width: 120,
    },
    {
      title: '6分数量',
      dataIndex: 'score6Size',
      width: 120,
    },
    {
      title: '7分数量',
      dataIndex: 'score7Size',
      width: 120,
    },
    {
      title: '8分数量',
      dataIndex: 'score8Size',
      width: 120,
    },
    {
      title: '9分数量',
      dataIndex: 'score9Size',
      width: 120,
    },
    {
      title: '10分数量',
      dataIndex: 'score10Size',
      width: 120,
    },
    {
      title: '负向标签',
      dataIndex: 'negativeTag',
      width: 300,
      render: (text:any) => {
        let displayText = '';
        displayText = Object.keys(text).length > 0
          ? Object.entries(text)
            .map(([tag, count]) => `${tag}：${count}`)
            .join('，')
          : '';
        return (
          <Tooltip title={displayText} placement="topLeft">
            <div style={{ ...CELL_STYLE, width:300 }}>
              {displayText}
            </div>
          </Tooltip>
        )
      },
    },
  ],
  search: false,
  footer: false,
}